module.exports = __webpack_public_path__ + "/images/logo-hellobb-blog-light.bf19b6a.svg";